import React, { createContext, useState, useEffect } from 'react';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const storedCart = localStorage.getItem('cart');
    if (storedCart) {
      setCart(JSON.parse(storedCart));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product, quantityToAdd = 1) => {
    const productId = product._id || product.id;
    const variantId = product.selectedVariant?._id;
    
    // Create a unique key for product + variant combination
    const itemKey = variantId ? `${productId}_${variantId}` : productId;
    
    const existingItem = cart.find(item => {
      const existingItemId = item._id || item.id;
      const existingVariantId = item.selectedVariant?._id;
      const existingKey = existingVariantId ? `${existingItemId}_${existingVariantId}` : existingItemId;
      return existingKey === itemKey;
    });
    
    if (existingItem) {
      setCart(cart.map(item => {
        const itemId = item._id || item.id;
        const itemVariantId = item.selectedVariant?._id;
        const currentKey = itemVariantId ? `${itemId}_${itemVariantId}` : itemId;
        
        return currentKey === itemKey
          ? { ...item, quantity: item.quantity + quantityToAdd }
          : item;
      }));
    } else {
      setCart([...cart, { ...product, quantity: quantityToAdd }]);
    }
  };

  const removeFromCart = (productId) => {
    setCart(cart.filter(item => (item._id || item.id) !== productId));
  };

  const updateQuantity = (productId, quantity) => {
    if (quantity <= 0) {
      removeFromCart(productId);
    } else {
      setCart(cart.map(item =>
        (item._id || item.id) === productId ? { ...item, quantity } : item
      ));
    }
  };

  const clearCart = () => {
    setCart([]);
  };

  const getCartTotal = () => {
    return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  const getCartCount = () => {
    // Return number of unique items (not total quantity)
    return cart.length;
  };

  return (
    <CartContext.Provider value={{
      cart,
      addToCart,
      removeFromCart,
      updateQuantity,
      clearCart,
      getCartTotal,
      getCartCount
    }}>
      {children}
    </CartContext.Provider>
  );
};
